import React, { useEffect, useState } from 'react'; // Import useEffect and useState
import axios from 'axios'; // Import axios
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesomeIcon
import { faMagnifyingGlass, faRightFromBracket } from '@fortawesome/free-solid-svg-icons'; // Import specific icons
import { LinkIcon } from "@heroicons/react/24/outline";
import LoadingAnimation from './LoadingAnimation';
import SiteSurvey from './orders/SitesSurvery';
import Installation from './orders/Installation';
import SendAgreement from './orders/sendAgreement';
import CustomerProfileForm from './orders/CustomerProfileForm';
import { Info } from "lucide-react";
import AgreementView from './orders/AgreementView';
import FilterModal from './orders/FilterModal';
import imageCompression from "browser-image-compression";
import * as pdfjsLib from "pdfjs-dist/webpack";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";

const HomeBackend = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const [totalOrganizations, setTotalOrganizations] = useState(0);
  const [loading, setLoading] = useState(true); // Loading state
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpensite, setIsOpensite] = useState(false);
  const [approvalType, setApprovalType] = useState('normal');
  const [attachment, setAttachment] = useState(null);
  const [recordType, setrecordType] = useState('');
  const [attachmentPreview, setAttachmentPreview] = useState(null); // For image preview
  const [id, setid] = useState(null)
  const [comment, setComment] = useState('');
  const [amount, setAmount] = useState('');
  const [selectpreoderid, setselectedoderid] = useState("")
  const [selectCustomerId, setselectedCustomerId] = useState("")
  const [siteSurvey, setSiteSurvey] = useState({
    DateofSiteSurvey: null,
    siteSurveycomment: "",
    TimeofSiteSurvey: null
  })
  const [installationDetails, setInstallationDetails] = useState({
    DateofInstallation: null,
    TimeofInstallation: null,
    installtioncomment: "",
    productSelection: 'custom',
    selectedMaterials: [],
    customerBillingDate: ""
  })
  const [isOpenInstallation, setIsOpenInstallation] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [eStampChoice, setEStampChoice] = useState(null);
  const [isSendAgreementOpen, setIsSendAgreementOpen] = useState(false);
  const [isPhysicalAgreementOpen, setIsPhysicalAgreementOpen] = useState(false);
  const [isCustomerDocumentOpen, setIsCustomerDocumentOpen] = useState(false);
  const [apiMaterials, setApiMaterials] = useState([]);
  const [take3MonthPayment, setTake3MonthPayment] = useState(false);
  const [agreementview, setagreementview] = useState(false)
  const [customerDocumentview, setCustomerDocumentview] = useState(false)
  const [customerprofileOpen, setCustomerprofileOpen] = useState(false)
  const [statusOpen, setStatusOpen] = useState(false)
  const [installationStatus, setInstallationStatus] = useState("NA");
  const [selectpdf, setSelectedPdf] = useState('')
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [filters, setFilters] = useState({
    verification: "",
    token: "",
    installationStatus: "",
    dateRange: { start: "", end: "" },
    quickRange: "",
    clearfilter: false,
  });
  let user = localStorage.getItem("userName")
   const adminUsers = [
    "Sales Admin",
    "Vineet Vidyanand",
    "Gajanan Padhar",
    "Karishma"
  ];
  const isAdminUser = adminUsers.includes(user);
  const itemsPerPage = 10; // same as `limit`
  // useEffect(() => {
  //   if (originalData.length === 0 && data.length > 0) {
  //     setOriginalData(data);
  //   }
  // }, [data]);

  // useEffect(() => {
  //   const applyFilters = async () => {
  //     let filtered = [...originalData];
  //     let matchingInstallationIds = [];
  //     let allSeenInstallationIds = [];

  //     const { installationStatus, dateRange } = filters;

  //     // Step 1: Fetch installation data if needed
  //     if (
  //       ["Installation Planned", "Installation Started", "Installation Completed", "Installation Requested"].includes(installationStatus) &&
  //       dateRange.start && dateRange.end
  //     ) {
  //       try {
  //         const res = await fetch(
  //           `https://servicebackend.circolife.vip/api/installation/getInstallationDetailsByDateRange?startDate=${dateRange.start}&endDate=${dateRange.end}`
  //         );
  //         const { data: installationData = [] } = await res.json();

  //         allSeenInstallationIds = installationData.map(
  //           entry => entry.parentPreOrderId || entry.preOrderId
  //         );

  //         if (installationStatus === "Installation Requested") {
  //           // Get IDs NOT present in any installation record
  //           matchingInstallationIds = originalData
  //             .filter(doc =>
  //               !allSeenInstallationIds.includes(doc._id) &&
  //               doc.isAgreementSigned === true
  //             )
  //             .map(doc => doc._id);
  //         } else {
  //           // Match devices' status with selected status
  //           matchingInstallationIds = installationData
  //             .filter(entry =>
  //               entry.devices?.some(device => device.status === installationStatus)
  //             )
  //             .map(entry => entry.parentPreOrderId);
  //         }
  //       } catch (err) {
  //         console.error("Installation status fetch error:", err);
  //         setData([]); // Avoid showing incorrect data
  //         return;
  //       }
  //     }

  //     // Step 2: Apply Date Range filter
  //     if (dateRange.start && dateRange.end) {
  //       const start = new Date(dateRange.start);
  //       const end = new Date(dateRange.end);
  //       filtered = filtered.filter(doc => {
  //         const docDate = new Date(doc.preOrdertimestamp);
  //         return docDate >= start && docDate <= end;
  //       });
  //     }

  //     // Step 3: Apply Verification
  //     if (filters.verification) {
  //       filtered = filtered.filter(doc => {
  //         const hasDetails = doc.verificationDetails && Object.keys(doc.verificationDetails).length > 0;
  //         return (
  //           (filters.verification === "done" && hasDetails) ||
  //           (filters.verification === "not_done" && !hasDetails)
  //         );
  //       });
  //     }

  //     // Step 4: Apply Token
  //     if (filters.token) {
  //       filtered = filtered.filter(doc => {
  //         return (
  //           (filters.token === "received" && doc.paidamount > 0) ||
  //           (filters.token === "pending" && doc.paidamount === 0)
  //         );
  //       });
  //     }

  //     // Step 5: Apply Installation Filters
  //     if (installationStatus) {
  //       if (matchingInstallationIds.length > 0) {
  //         filtered = filtered.filter(doc =>
  //           matchingInstallationIds.includes(doc._id)
  //         );
  //       } else {
  //         // If the matching IDs are empty (e.g., no match in API)
  //         filtered = [];
  //       }
  //     }

  //     // Step 6: Clear filter case
  //     if (filters.clearfilter) {
  //       setData(originalData);
  //       setFilters(prev => ({
  //         ...prev,
  //         verification: "",
  //         token: "",
  //         installationStatus: "",
  //         dateRange: { start: "", end: "" },
  //         quickRange: "",
  //         clearfilter: false
  //       }));
  //       return;
  //     }

  //     setData(filtered);
  //   };

  //   applyFilters();
  // }, [filters, originalData]);

  useEffect(() => {
    if (statusOpen) {
      fetchInstallationStatus();
    }
  }, [statusOpen]);
  useEffect(() => {
    fetchMaterials().then((materials) => {
      // console.log({materials})
      setApiMaterials(materials);
    });
  }, []);
  // useEffect(() => {
  //   fetchPreOrders();
  // }, [isOpenInstallation, isOpen]);


  // useEffect(() => {
  //   setFilteredData(
  //     data.filter((item) => {
  //       const nameMatch = item.customer.name
  //         .toLowerCase()
  //         .includes(searchQuery.toLowerCase());
  //       const execMatch =
  //         user === "Sales Admin" &&
  //         item.executive_id?.toLowerCase().includes(searchQuery.toLowerCase());

  //       const mobMatch =
  //         user === "Sales Admin" &&
  //         item.customer.mobile.includes(searchQuery);

  //       return nameMatch || execMatch || mobMatch;
  //     })
  //   );

  // }, [searchQuery, data]);






  const fetchInstallationStatus = async () => {
    try {
      const response = await axios.get(`https://servicebackend.circolife.vip/api/installation/getInstallationDetails/${selectpreoderid}`)
      const data = response.data;
      if (!data || data.length === 0) {
        setInstallationStatus("No Installation Data");
        return;
      }
      const devices = data[0]?.devices || [];
      if (devices.length === 0) {
        setInstallationStatus("No Devices Found");
        return;
      }
      const statusString = devices
        .map(device => `${device.deviceName} - ${device.status}`)
        .join(", ");

      setInstallationStatus(statusString);
    } catch (error) {
      console.error("Error fetching status:", error);
      setInstallationStatus("Error");
    }
  };




  const fetchMaterials = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_MYBACKEND_PI}/api/extraMaterial/get-extra-materials`)
      if (response.data && response.data.materials) {
        return response.data.materials;
      } else {
        console.error("Invalid API response:", response.data);
        return [];
      }


    } catch (error) {
      console.error("Error fetching materials:", error);
      return [];
    }
  };



  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setAttachment(file);

    // Generate a preview URL for the image
    if (user === "Karishma" || (file && file.type.startsWith('image/'))) {
      const reader = new FileReader();
      reader.onload = (e) => setAttachmentPreview(e.target.result);
      reader.readAsDataURL(file);
    } else {
      setAttachmentPreview(null); // Clear preview if not an image
    }
  };

  const removeAttachment = () => {
    setAttachment(null);
    setAttachmentPreview(null);
  };
  let currentItems = []




  const uploadPdfToS3 = async (pdfBlob, fileName) => {
    try {
      // Convert blob → Base64
      const base64Data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(pdfBlob);
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1]; // remove prefix
          resolve(base64String);
        };
        reader.onerror = (err) => reject(err);
      });

      const fileKey = `invoices/${fileName}`;

      const response = await fetch(`${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/upload-file`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          file: base64Data,
          mimetype: "application/pdf",
          fileKey
        }),
      });

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || "Upload failed");
      }

      return result.data.fileUrl; // ✅ S3 file URL
    } catch (error) {
      console.error("Error uploading PDF:", error);
      throw new Error("Failed to upload PDF");
    }
  };

  const generatePresignedUrl = async (fileName) => {
    try {
      if (!fileName) {
        console.error("File name is required");
        return null;
      }

      const res = await fetch(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/presigned-url`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            key: `invoices/${fileName}`,
          }),
        }
      );

      const data = await res.json();

      if (!data?.success || !data?.url) {
        throw new Error("Failed to get pre-signed URL");
      }

      return data.url;

    } catch (error) {
      console.error("Error generating pre-signed URL:", error);
      return null;
    }
  };


  const sendApprovalRequest = async (imageUrl) => {
    setLoading(true);
    try {
      // Fetch existing preorder data
      const currentDataResponse = await axios.get(`${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${id}`);
      const currentTransactions = currentDataResponse.data.aproveldata?.transactions || [];
      // Prepare updated transactions
      const updatedTransactions = [
        ...currentTransactions,
        { amount, attachmentUrl: imageUrl }
      ];

      // Update preorder data
      const response = await axios.put(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/recordpayment/${id}`,
        {
          transactions: updatedTransactions,
          comment,
          approvalType,
          approvalStatus: false,
          recordType
        }
      );
      // console.log(response, "check response")
      // Verify the response contains the updated data
      if (!response.data || !response.data.data.aproveldata.transactions) {
        alert('Server response missing updated transaction data');
      }

      return response.data; // Return the response for verification
    } catch (error) {
      throw error; // Propagate the error to be handled by the caller
    } finally {
      setLoading(false);
    }
  };


  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 0.5, // Limit size to 0.5MB
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };
    return await imageCompression(file, options);
  };

  const compressPdf = async (file) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    return new Promise((resolve, reject) => {
      reader.onload = async () => {
        try {
          const pdfBytes = new Uint8Array(reader.result);
          const pdf = await pdfjsLib.getDocument({ data: pdfBytes }).promise; // Load PDF
          const newPdf = new jsPDF();

          for (let i = 0; i < pdf.numPages; i++) {
            const page = await pdf.getPage(i + 1);
            const viewport = page.getViewport({ scale: 1.5 });

            // Create canvas
            const canvas = document.createElement("canvas");
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            const ctx = canvas.getContext("2d");

            // Render PDF page to canvas
            await page.render({ canvasContext: ctx, viewport }).promise;

            // Convert canvas to JPEG with compression
            const imgData = canvas.toDataURL("image/jpeg", 0.5);

            if (i > 0) newPdf.addPage();
            newPdf.addImage(imgData, "JPEG", 5, 5, 200, 280);
          }

          // Convert new PDF to Blob
          const compressedPdfBlob = new Blob([newPdf.output("blob")], {
            type: "application/pdf",
          });
          resolve(
            new File([compressedPdfBlob], file.name, {
              type: "application/pdf",
            })
          );
        } catch (error) {
          console.error("PDF compression failed:", error);
          reject(error);
        }
      };
    });
  };

  const compressAndSendImage = async (imageFile) => {
    try {
      // Compress the image before sending
      if (imageFile.type.startsWith("image/")) {
        imageFile = await compressImage(imageFile);
      } else if (imageFile.type === "application/pdf") {
        imageFile = await compressPdf(imageFile);
      }
      return sendFileToServer(imageFile);
    } catch (error) {
      console.error('Error processing image:', error);
    }
  };


  const calculateDimensions = (originalWidth, originalHeight) => {
    // For mobile uploads, these dimensions provide good balance
    // between quality and file size
    const MAX_WIDTH = 1080;
    const MAX_HEIGHT = 1080;

    let width = originalWidth;
    let height = originalHeight;

    // Resize if image is larger than our maximums
    if (width > height) {
      if (width > MAX_WIDTH) {
        height = Math.round(height * MAX_WIDTH / width);
        width = MAX_WIDTH;
      }
    } else {
      if (height > MAX_HEIGHT) {
        width = Math.round(width * MAX_HEIGHT / height);
        height = MAX_HEIGHT;
      }
    }

    return { width, height };
  };

  const sendFileToServer = async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await axios.post(`${process.env.REACT_APP_MYBACKEND_PI}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data.normalUrl;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  };


  const handleSubmit = async () => {
    try {

      setIsLoading(true);

      if (!approvalType || !recordType) {
        alert("VALIDATION_ERROR: Approval type and record type are required.");
        setIsLoading(false); // Stop loading when validation fails
        return;
      }

      // Validate amount format
      if (amount && (!Number(amount) || Number(amount) <= 0)) {
        alert("VALIDATION_ERROR: Please enter a valid amount.");
        setIsLoading(false); // Stop loading when validation fails
        return;
      }

      // Validate fields based on type
      const missingFields = [];

      switch (true) {
        case approvalType === "normal" && recordType === "qrcode":
          if (!amount) missingFields.push("Amount");
          if (!attachment) missingFields.push("Attachment");
          break;

        case approvalType === "special":
          if (!comment?.trim()) {
            alert("VALIDATION_ERROR: Comment is required for special approval.");
            setIsLoading(false); // Stop loading when validation fails
            return;
          }
          break;

        case recordType === "normal" || recordType === "custom":
          if (!amount) missingFields.push("Amount");
          break;
      }

      if (missingFields.length) {
        alert(`VALIDATION_ERROR: Required fields missing: ${missingFields.join(", ")}`);
        setIsLoading(false); // Stop loading when validation fails
        return;
      }

      // Validate attachment if present
      if (attachment) {
        if (user != "Karishma") {
          if (!attachment.type?.startsWith('image/')) {
            alert("VALIDATION_ERROR: Only image files are allowed.");
            setIsLoading(false); // Stop loading when validation fails
            return;
          }
        }

        const maxSize = 5 * 1024 * 1024;
        if (attachment.size > maxSize) {
          alert("VALIDATION_ERROR: Image size exceeds 5MB limit.");
          setIsLoading(false); // Stop loading when validation fails
          return;
        }
      }

      // Amount confirmation
      if (amount && !window.confirm(`💰 You have entered an amount of ₹${amount}.❓ Do you want to proceed?`)) {
        alert("USER_CANCELLED: Amount confirmation cancelled.");
        setIsLoading(false); // Stop loading when user cancels
        return;
      }

      // Handle custom payment
      if (recordType === "custom") {
        try {
          const preOrderResponse = await axios.get(
            `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${id}`,
            { headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` } }
          );

          const { name, email, mobile: contact, customer_id } = preOrderResponse.data.customer;

          const paymentResponse = await axios.post(
            `${process.env.REACT_APP_MYBACKEND_PI}/create-payment-link`,
            {
              description: "Circolife AC Custom Payment",
              amount,
              name,
              email,
              contact,
              paymentLinktype: "custom",
              customer_id,
              customer: name,
              preOrderId: id
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
              }
            }
          );

          setIsLoading(false); // Stop loading on success
          alert("Payment link created successfully!");
          handleReset();
          return;
        } catch (error) {
          console.error("Payment link creation error:", error);
          alert(`Payment Error: ${error.response?.data?.message || 'Failed to create payment link'}`);
          setIsLoading(false); // Stop loading on error
          return;
        }
      }

      // Remove this line since we're already using setIsLoading
      // setLoading(true);

      // Handle image upload
      let imageUrl = '';
      if (attachment) {
        // console.log("File Type:", attachment.type);
        // console.log("File Size:", attachment.size);
        try {
          // console.log(attachment, "checkimageattached");       
          imageUrl = await compressAndSendImage(attachment);
          if (!imageUrl) throw new Error("Failed to get image URL");
        } catch (error) {
          console.error("Upload error:", error);
          alert(`UPLOAD_ERROR: ${error.message}`);
          setIsLoading(false); // Stop loading on error
          return;
        }
      }

      // Process approval request
      await sendApprovalRequest(imageUrl);
      setIsOpen(false);
      alert("Submission successful!");
      setIsLoading(false); // Stop loading after successful submission

    } catch (error) {
      console.error("Submission error:", error);
      alert(error.message.includes(":") ? error.message.split(":")[1].trim() : "Request failed. Please try again.");
      setIsLoading(false); // Stop loading on error
    } finally {
      handleReset();
    }
  };

  const handleReset = () => {
    setIsOpen(!isOpen)
    setLoading(false);
    setAmount('');
    setComment('');
    setAttachment(null);
    setrecordType('');
  };

  const CancelHanlder = async () => {
    setIsOpen(!isOpen)
    setAmount('');
    setComment('');
    setAttachment('');
    setrecordType('');


  }
  const handleOrderCreation = () => {
    navigate("/orders", { state: { isExisting: false, apiMaterials, take3MonthPayment } });
  };







  const fetchPreOrders = async () => {
    try {
      if (searchQuery) {
        setCurrentPage(1)
        const response = await axios.post(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/filter/data`,
          {
            page: currentPage,
            limit: itemsPerPage,
            search: searchQuery,
            startDate: filters.dateRange.start,
            endDate: filters.dateRange.end,
            verificationStatus: filters.verification,
            tokenStatus: filters.token
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            }
          }
        );


        setData(response.data.data);
        setTotalOrganizations(response.data.total);
        setTotalPages(response.data.totalPages); // Set page count
      } else {
        const response = await axios.post(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/filter/data`,
          {
            page: currentPage,
            limit: itemsPerPage,
            search: searchQuery,
            startDate: filters.dateRange.start,
            endDate: filters.dateRange.end,
            verificationStatus: filters.verification,
            tokenStatus: filters.token
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            }
          }
        );
        setData(response.data.data);
        setTotalOrganizations(response.data.total);
        setTotalPages(response.data.totalPages); // Set page count
      }
    } catch (error) {
      console.error("Error creating PreOrder:", error.response ? error.response.data : error.message);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };



  useEffect(() => {
    if (searchQuery === "" || searchQuery.length >= 3) {
      fetchPreOrders();
    }
  }, [searchQuery, currentPage, filters]);




  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };


  const handleLogout = () => {
    localStorage.removeItem("authToken")
    localStorage.removeItem('userName')
    localStorage.removeItem('state');
    navigate('/', { replace: true });
    window.location.reload(); // refresh the page
  };
  const quryhandlerClassic = () => {
    window.open(`${process.env.REACT_APP_RISE_QUERY}`, '_blank');
  };
  const quryhandler = () => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      alert('Authentication required');
      return;
    }

    const queryURL = new URL(process.env.REACT_APP_BETA_QUERY);
    queryURL.searchParams.append('from', "CCT");
    queryURL.searchParams.append('auth', token);

    // Open in a new tab
    window.open(queryURL.toString(), '_blank');
  };
  const deleteHandler = (item) => {
    console.log(item, "checke")
    axios({
      method: "DELETE",
      url: `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${item}`
    }).then((res) => {
      fetchPreOrders()
    }).catch((err) => {
      console.log(err)
    })
  }



  const createInstallationItem = (type, quantity, charge, itemId) => {
    if (quantity > 0 && charge >= 0) { // Check if charge is also valid
      const unitPrice = charge / 1.18; // This assumes 18% tax
      return {
        id: itemId,
        name: `Installation (${type} AC)`,
        quantity: quantity,
        unit_price: unitPrice,
        tax_rate: 18,
        price_with_tax: charge,
        item_type: 'Service',
        net_amount: unitPrice * quantity,
        total_amount: charge * quantity,
      };
    }
    return null; // Return null if quantity or charge is invalid
  };
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const mapProduct = (acModel, item, take3MonthPayment) => {
    const models = {
      '10': {
        id: 'mlmc_3y_1t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 1T',
        unitPrice: 1014.84,
        priceWithTax: 1299,
      },
      '15': {
        id: 'mlmc_3y_1.5t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 1.5T',
        unitPrice: 1092.97,
        priceWithTax: 1399,
      },
      '20': {
        id: 'mlmc_3y_2t_p', // Default for Split
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 2T',
        unitPrice: 1327.34,
        priceWithTax: 1699,
      },
      '30': {
        id: 'mlcmc_2y_3t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 2Y 30T',
      }
    };
    if (item.acType === 'Cassette') {
      models['20'] = {
        id: 'mlmc_cassette_5y_2t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 5Y 2T-Cassete',
        unitPrice: 1952.34,
        priceWithTax: 2499,
      };
      models['30'] = {
        id: 'mlmc_cassette_5y_3t_p',
        name: 'Monthly Leasing and Maintenance charges of Air Conditioner - 5Y 3T-Cassete',
        unitPrice: 2342.96,
        priceWithTax: 2999,
      }
    }
    const model = models[acModel];

    if (!model) {
      throw new Error('Invalid acModel provided.');
    }

    const baseQuantity = item.quantity;
    const isMonthlyLeasing =
      model.id?.startsWith("mlmc_") ||
      model.name?.toLowerCase().includes("monthly leasing");
    const adjustedQuantity =
      take3MonthPayment && isMonthlyLeasing ? baseQuantity * 3 : baseQuantity;
    const adjustedtotalSubscription =
      take3MonthPayment && isMonthlyLeasing
        ? item.totalSubscription * 3
        : item.totalSubscription;
    let priceWithTax = Number(adjustedtotalSubscription / adjustedQuantity);
    let unitPrice = adjustedtotalSubscription / adjustedQuantity / 1.18;
    return {
      id: model.id,
      name: model.name,
      quantity: adjustedQuantity,
      unit_price: unitPrice,
      tax_rate: 18,
      price_with_tax: priceWithTax,
      item_type: 'Service',
      net_amount: unitPrice * adjustedQuantity,
      total_amount: adjustedtotalSubscription
    };
  };

  const mapMaterial = (items) => {
    const materials = apiMaterials.reduce((acc, material) => {
      acc[material.material_code] = {
        id: material.material_code,
        name: material.material_name, // Convert underscores to spaces for readability
        unit_price: material.unit_price,
        price_with_tax: material.price_with_tax,
      };
      return acc;
    }, {});
    // Check if items is an array
    if (!Array.isArray(items)) {
      alert('Expected an array but got:', items);
      return []; // Return an empty array instead of null
    }

    // Map over the provided items and dynamically build the material objects
    return items.map((item) => {
      const material = materials[item.materialType.toLowerCase().replace(/\s+/g, '_')];
      if (!material) {
        alert("Material type not found for:", item.materialType);
        return null; // If no matching material is found, return null
      }

      // Ensure quantity and price are numbers
      const quantity = Number(item.quantity);
      const price = Number(item.price);
      let priceWithTax = Number(item.totalAmount / quantity)
      let unitPrice = priceWithTax / 1.18;
      return {
        id: material.id,
        name: material.name,
        quantity: quantity, // Correctly formatted quantity
        unit_price: unitPrice, // Static unit price from materials
        tax_rate: 18, // Static tax rate
        price_with_tax: priceWithTax, // Total amount from input
        item_type: 'Product', // Static type 'Material'
        net_amount: unitPrice * quantity, // Net amount excluding tax
        total_amount: item.totalAmount // Total amount with tax
      };
    }).filter(item => item !== null); // Filter out any null values if materials are not found
  };
  const mapRefundableDeposit = (acModel, ton, duration, quantity, totalAmount) => {
    const refundableDeposits = {
      'Split': {
        '3year': {
          '10': {
            id: 'refund_3y_1t_p',
            name: 'Refundable Deposit - 1T',
          },
          '15': {
            id: 'refund_3y_1.5t_p',
            name: 'Refundable Deposit - 1.5T',
          },
          '20': {
            id: 'refund_3y_2t_p',
            name: 'Refundable Deposit - 2T',
          },
        },
        '3+3year': {
          '10': {
            id: 'refund_3y_1t_p',
            name: 'Refundable Deposit - 1T',
          },
          '15': {
            id: 'refund_3y_1.5t_p',
            name: 'Refundable Deposit - 1.5T',
          },
          '20': {
            id: 'refund_3y_2t_p',
            name: 'Refundable Deposit - 2T',
          },
        },
        '5years': {
          '10': {
            id: 'refund_5y_1t_p',
            name: 'Refundable Deposit - 1T',
          },
          '15': {
            id: 'refund_5y_1.5t_p',
            name: 'Refundable Deposit - 1.5T',
          },
          '20': {
            id: 'refund_5y_2t_p',
            name: 'Refundable Deposit - 2T',
          },
        },
      },
      'Cassette': {
        '20': {
          id: 'refund_cassette_2t_p',
          name: 'Refundable Deposit - Cassette 2 Ton',
        },
        '30': {
          id: 'refund_cassette_3t_p',
          name: 'Refundable Deposit - Cassette 3 Ton',
        },
      },
    };

    // Check for valid AC model
    if (!refundableDeposits[acModel]) {
      alert(`Invalid AC model provided: ${acModel}`);
      return null;
    }

    let deposit;
    if (acModel === 'Split') {
      // Check for valid duration
      if (!refundableDeposits[acModel][duration]) {
        alert(`Invalid duration provided for Split AC: ${duration}`);
        return null;
      }
      // Check for valid tonnage
      deposit = refundableDeposits[acModel][duration][ton];
      if (!deposit) {
        alert(`Invalid tonnage provided for duration ${duration} in Split AC model: ${ton}`);
        return null;
      }
    } else if (acModel === 'Cassette') {
      // Check for valid tonnage
      deposit = refundableDeposits[acModel][ton];
      if (!deposit) {
        alert(`Invalid tonnage provided for Cassette AC model: ${ton}`);
        return null;
      }
    }

    // Calculate unit price and price with tax dynamically

    let priceWithTax = Number(totalAmount / quantity)
    let unitPrice = priceWithTax;

    return {
      id: deposit.id,
      name: deposit.name,
      quantity: Number(quantity),
      unit_price: parseInt(unitPrice.toFixed(2)),
      tax_rate: 0,
      price_with_tax: parseInt(priceWithTax.toFixed(2)),
      item_type: 'Service',
      net_amount: unitPrice * quantity,
      total_amount: totalAmount,
    };
  };

  const createPIInvoice = async (savedItems, materials, customerdata, selectedShippingAddress, billingAddress, splitInstallationCharge, cassetteInstallationCharge, pending_amount, preOrderId, pilink, totalReceivedAmount, totalPaidAmount, totalPendingAmount, take3MonthPayment) => {
    try {
      const currentDate = formatDate(new Date());
      const futureDate = formatDate(new Date(new Date().setFullYear(new Date().getFullYear() + 3)));
      const invoiceItems = savedItems.map((item) => {
        return mapProduct(item.ton, item, take3MonthPayment);
      });
      const splitItems = savedItems.filter(item => item.acType === "Split");
      const cassetteItems = savedItems.filter(item => item.acType === "Cassette");

      const totalSplitQuantity = splitItems.reduce((sum, item) => sum + item.quantity, 0);
      const totalCassetteQuantity = cassetteItems.reduce((sum, item) => sum + item.quantity, 0);
      const splitInstallationItem = createInstallationItem('Split', totalSplitQuantity, splitInstallationCharge, 'install_1500_p');
      const cassetteInstallationItem = createInstallationItem('Cassette', totalCassetteQuantity, cassetteInstallationCharge, 'install_cassette_p');

      if (splitInstallationItem) {
        invoiceItems.push(splitInstallationItem);
      }
      if (cassetteInstallationItem) {
        invoiceItems.push(cassetteInstallationItem);
      }
      savedItems.forEach(item => {
        const acModel = item.acType === 'Cassette' ? 'Cassette' : 'Split';
        let duration = null;
        if (acModel === 'Split') {
          duration = item.plan === "3+2year" ? "5years" : (item.plan || "5years");
        }
        const refundableItem = mapRefundableDeposit(acModel, item.ton, duration, item.quantity, item.totalDeposit);
        refundableItem.total_amount = item.depositamount * item.quantity;
        invoiceItems.push(refundableItem);
      });
      const materialItems = mapMaterial(materials);
      materialItems.forEach(material => {
        if (material) {
          invoiceItems.push(material);
        }
      });
      // Invoice details
      const invoice = {
        document_type: 'pro_forma_invoice',
        document_date: currentDate,
        party: {
          id: customerdata.customer_id,
          name: customerdata.name,
          email: customerdata.email,
          ...(billingAddress.gst_number && { gstin: billingAddress.gst_number }),
          type: 'customer',
          shipping_address: {
            addr_id_v2: selectedShippingAddress.addressid || "1",
            address_line1: selectedShippingAddress.line1,
            address_line2: selectedShippingAddress.line2,
            pincode: selectedShippingAddress.pincode,
            city: selectedShippingAddress.city,
            country: 'India',
            state: selectedShippingAddress.state,
          },
          // Conditionally add customer_billing_address if gstin.number exists
          billing_address: {
            addr_id_v2: "1",
            address_line1: billingAddress.address_line1,
            address_line2: billingAddress.address_line2,
            pincode: billingAddress.pincode,
            city: billingAddress.city,
            country: 'India',
            state: billingAddress.state,
          },
        },
        items: invoiceItems,
        notes: `Start Date : ${currentDate} End Date: ${futureDate}`,
        round_off: true,
        bank_details: {
          account_number: "10217543754",
          ifsc: "IDFB0040101",
          bank_name: "IDFC FIRST Bank",
          branch: "BKC NAMAN CHAMBERS BRANCH"
        }
      };
      if (billingAddress.gst_number) {
        invoice.party.gstin = billingAddress.gst_number;
      }
      setIsLoading(true);
      let fileName;
      let pdfBlob;
      let presignedUrl;
      const formData = new FormData();
      const token = `${process.env.REACT_APP_SWIPE_TOKEN}`;
      const swipeResponse = await axios.post(
        `${process.env.REACT_APP_SWIPE_BASE_URL}/api/partner/v2/doc`,
        invoice,
        {
          headers: {
            Authorization: token
          }
        }
      );

      const hashId = swipeResponse.data.data.hash_id;
      const pdfResponse = await axios.get(
        `${process.env.REACT_APP_SWIPE_BASE_URL}/api/partner/v2/doc/pdf/${hashId}`,
        {
          headers: {
            Authorization: token
          },
          responseType: 'arraybuffer'
        }
      );

      pdfBlob = new Blob([pdfResponse.data], { type: 'application/pdf' });
      fileName = `invoice_${hashId}.pdf`
      const pdfurl = await uploadPdfToS3(pdfBlob, fileName)
      updateurl(pdfurl, preOrderId)
      presignedUrl = await generatePresignedUrl(fileName);

      formData.append('pro_forma_invoice', pdfBlob, fileName)
      formData.append('customername', customerdata.name);
      formData.append('customeremail', customerdata.email);
      const pdfUploadResponse = await axios.post(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/generatePI/send-invoice`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );
      setIsLoading(false);
      sendWhatsAppMessage(customerdata.mobile, presignedUrl, customerdata.name, pending_amount, totalReceivedAmount, totalPaidAmount, totalPendingAmount)
      alert("📄 Pre-Order Invoice Sent Successfully!");

      return;

    } catch (error) {
      setIsLoading(false);
      alert(`Error creating invoice or processing payment: ${error.response ? error.response.data : error.message}`);
    }
  };

  const fetchPreOrderData = async (itemId) => {
    if (itemId !== undefined) {
      try {
        const response = await axios({
          url: `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${itemId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }).then((res) => {
          // console.log("response", res);
          // Calculate installation charges
          // Extract single installation charges for cassette and split
          let cassetteInstallationCharge = null;
          let splitInstallationCharge = null;

          res.data.AcDetails.forEach((item) => {
            if (cassetteInstallationCharge === null && item.ac_type.toLowerCase() === "cassette") {
              cassetteInstallationCharge = item.installation_price;
            }
            if (splitInstallationCharge === null && item.ac_type.toLowerCase() === "split") {
              splitInstallationCharge = item.installation_price;
            }
          });

          let transformedAcDetails = res.data.AcDetails.map((item) => ({
            acType: item.ac_type,
            ton: item.model.replace(/^[SC]/, ""), // Remove leading 'S' or 'C'
            plan: item.plan_year,
            quantity: item.quantity,
            subscription_plan: item.subscription_price,
            depositamount: item.deposit,
            installetionCharge: item.installation_price,
            totalSubscription: item.subscription_price * item.quantity,
            totalDeposit: item.deposit * item.quantity,
            totalInstallation: item.installation_price * item.quantity,
            priceAfter3Years: item.fixedPriceAfter3Years,
            totalAfter3Years: item.fixedPriceAfter3Years * item.quantity,
            totalAmount:
              item.subscription_price * item.quantity +
              item.deposit * item.quantity +
              item.installation_price * item.quantity,
            fixedPriceAfter3Years: item.fixedPriceAfter3Years,
            id: Date.now() + Math.floor(Math.random() * 1000), // Unique ID
          }));

          // Transforming materials details
          let transformedMaterials = res.data.materialsdetails.map((material) => ({
            materialType: material.material_name,
            quantity: Number(material.quantity),
            price: Number(material.material_price),
            totalAmount: Number(material.quantity) * Number(material.material_price),
          }));
          const selectedAddress = {
            line1: res.data.customer_shipping_address.address_line1,
            line2: res.data.customer_shipping_address.address_line2,
            city: res.data.customer_shipping_address.city,
            state: res.data.customer_shipping_address.state,
            pincode: res.data.customer_shipping_address.pincode,
          };


          let billingAddress = res.data.customer_billing_address;
          if (!res.data.customer_billing_address.gst_number) {
            billingAddress = {
              gst_number: res.data.customer_billing_address.gst_number,
              address_line1: res.data.customer_billing_address.address_line1,
              address_line2: res.data.customer_billing_address.address_line2,
              pincode: res.data.customer_billing_address.pincode,
              city: res.data.customer_billing_address.city,
              state: res.data.customer_billing_address.state,
              country: res.data.customer_billing_address.country,
            };
          }
          createPIInvoice(transformedAcDetails, transformedMaterials, res.data.customer, selectedAddress, billingAddress, splitInstallationCharge, cassetteInstallationCharge, res.data.pending_amount, res.data._id, res.data.Pilink, (res.data.material_totalAmount + res.data.Ac_totalAmount), res.data.TotalReceivedAmount, (res.data.pending_amount + res.data.pending_material_amount), res.data.take3MonthPayment);
        });


      } catch (error) {
        console.error("Error fetching pre-order data:", error);
        // Optional: Show user-friendly error message
      }
    }
  };



  const sendWhatsAppMessage = async (customerMobile, pdfUrl, customerName, invoiceAmount, totalReceivedAmount, totalPaidAmount, totalPendingAmount) => {
    // console.log("inside the sendWhatsAppMessage function");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_WHATSAPP_URL}`,
        {
          apiKey: process.env.REACT_APP_WHATSAPP_KEY,
          campaignName: 'sendpiwithpaymentdetails',
          destination: `91${customerMobile}`,
          userName: 'PROCYON STAR PRIVATE LIMITED',
          templateParams: [customerName, String(totalReceivedAmount), String(totalPaidAmount), String(totalPendingAmount)],
          source: 'Invoice Process',
          media: {
            url: pdfUrl, // Use the S3 URL here
            filename: `Invoice_${customerName}.pdf`,
          },
          buttons: [],
        }
      );
      // console.log('WhatsApp message sent successfully:', response.data);
    } catch (error) {
      console.error('Error sending WhatsApp message:', error.response ? error.response.data : error.message);
      alert('Failed to send WhatsApp message. Please try again.');
    }
  };
  const updateurl = async (pdfurl, preOrderid) => {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/addpilinkurl`,
        {
          preOrderid: preOrderid,
          pilink: pdfurl,
        }
      );
      // console.log(res.data);
    } catch (err) {
      console.error('Error:', err);
    }
  };


  const handleActionChange = async (e, index, itemId) => {
    let updatedStatus = e.target.value;

    if (updatedStatus === "edit") {
      setTake3MonthPayment(itemId?.take3MonthPayment || false)
      navigate(`/orders/${itemId._id}`, { state: { isExisting: true, apiMaterials, take3MonthPayment: itemId?.take3MonthPayment || false } });
      return;
    } else if (updatedStatus === "PiSent") {
      await fetchPreOrderData(itemId._id);
      return;
    } else if (updatedStatus === "recordpayment") {
      setIsOpen(!isOpen);
      setid(itemId._id);
      return;
    } else if (updatedStatus === "site") {
      setIsOpensite(!isOpensite);
      setselectedoderid(itemId._id);
      return;
    }
    else if (updatedStatus === "customerprofile") {
      setCustomerprofileOpen(!customerprofileOpen)
      setselectedoderid(itemId._id);
      return;
    }
    else if (updatedStatus === "installtion") {
      setIsOpenInstallation(!isOpenInstallation)
      setselectedoderid(itemId._id);
      return;
    } else if (updatedStatus === "sendAgreement") {

      setIsSendAgreementOpen(!isSendAgreementOpen);
      setselectedoderid(itemId);
      return;
    } else if (updatedStatus === "uploadPhysicalAgreement") {
      setIsPhysicalAgreementOpen(!isPhysicalAgreementOpen);
      setselectedoderid(itemId);
      return;
    } else if (updatedStatus === "customerDocument") {
      setIsCustomerDocumentOpen(!isCustomerDocumentOpen);
      setselectedoderid(itemId);
      setselectedCustomerId(itemId.customer.customer_id)
      return;
    } else if (updatedStatus === "verificationForm") {
      navigate(`/verification-form/${itemId._id}`);
      return;
    }

    const itemIndex = (currentPage - 1) * itemsPerPage + index;
    const preOrderId = data[itemIndex]._id;
    const updatedItem = { ...data[itemIndex], status: updatedStatus };
    const newData = [...data];
    newData[itemIndex].status = ""; // Set the status to an empty string
    setData(newData); // Update the UI immediately

    try {
      setIsLoading(true); // Start loading before making API requests

      const preOrderResponse = await axios.get(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${preOrderId}`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );

      let pendingAmount = (!preOrderResponse.data.total_pending_amount) ? preOrderResponse.data.pending_amount : (preOrderResponse.data.total_pending_amount);
      let paymentLinkData;
      let patchData;
      let confirmMessage;

      if (updatedStatus === "fullpayment" && preOrderResponse.data.with_material === false) {
        confirmMessage = `💰 Confirm Full Payment for Circolife AC. Do you want to proceed?`;
      } else if (updatedStatus === "token") {

        let totalQuantity = 0;
        preOrderResponse.data.AcDetails.forEach(ac => {
          totalQuantity += ac.quantity;
        });
        let totaltoken = totalQuantity * 1000;
        if (pendingAmount < totaltoken) {
          alert("❌ Pending amount is less than the token amount. Payment cannot be processed.");
          setIsLoading(false); // Stop loading if the condition is not met
          return; // Exit the function
        }
        pendingAmount = totaltoken
        confirmMessage = `🔑 Confirm Token Payment for Circolife AC. Do you want to proceed?`;

      } else if (updatedStatus === "onlymaterial") {
        confirmMessage = `🔧 Confirm Only Material Payment for Circolife AC. Do you want to proceed?`;
      } else if (updatedStatus === "fullpayment" && preOrderResponse.data.with_material === true && preOrderResponse.data.pending_material_amount >= 0) {
        confirmMessage = `💸 Confirm Custom Payment of ${pendingAmount} for Circolife AC. Do you want to proceed?`;
      }

      const userConfirmed = window.confirm(confirmMessage);
      if (!userConfirmed) {
        setIsLoading(false); // Stop loading if the user cancels
        return;
      }

      // Prepare data for payment link based on the status
      if (updatedStatus === "fullpayment" && preOrderResponse.data.with_material === true) {
        paymentLinkData = {
          description: "Circolife AC Full Payment",
          amount: pendingAmount,
          name: preOrderResponse.data.customer.name,
          email: preOrderResponse.data.customer.email,
          contact: preOrderResponse.data.customer.mobile,
          paymentLinktype: "fullpayment",
          customer_id: preOrderResponse.data.customer.customer_id,
          customer: preOrderResponse.data.customer.name,
          preOrderId: preOrderId
        };
      } else if (updatedStatus === "token") {
        paymentLinkData = {
          description: "Circolife AC Token Payment",
          amount: pendingAmount,
          name: preOrderResponse.data.customer.name,
          email: preOrderResponse.data.customer.email,
          contact: preOrderResponse.data.customer.mobile,
          paymentLinktype: "token",
          customer_id: preOrderResponse.data.customer.customer_id,
          customer: preOrderResponse.data.customer.name,
          preOrderId: preOrderId
        };
      } else if (updatedStatus === "fullpayment" && preOrderResponse.data.with_material === false) {
        paymentLinkData = {
          description: "Circolife AC Custom Payment",
          amount: preOrderResponse.data.pending_amount,
          name: preOrderResponse.data.customer.name,
          email: preOrderResponse.data.customer.email,
          contact: preOrderResponse.data.customer.mobile,
          paymentLinktype: "customize",
          customer_id: preOrderResponse.data.customer.customer_id,
          customer: preOrderResponse.data.customer.name,
          preOrderId: preOrderId
        };
      } else if (updatedStatus === "onlymaterial") {
        paymentLinkData = {
          description: "Circolife AC Only Material Payment",
          amount: preOrderResponse.data.pending_material_amount,
          name: preOrderResponse.data.customer.name,
          email: preOrderResponse.data.customer.email,
          contact: preOrderResponse.data.customer.mobile,
          paymentLinktype: "onlymaterial",
          customer_id: preOrderResponse.data.customer.customer_id,
          customer: preOrderResponse.data.customer.name,
          preOrderId: preOrderId
        };
      }

      const paymentResponse = await axios.post(
        `${process.env.REACT_APP_MYBACKEND_PI}/create-payment-link`,
        paymentLinkData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );

      // Prepare patch data for updating the pre-order
      patchData = {
        status: paymentLinkData.paymentLinktype,
        paymentLinkId: paymentResponse.data.paymentLinkUrl,
        tokenAmount: paymentLinkData.amount, // for "token" and "customize"
      };

      // Update pre-order status and payment details
      await axios.patch(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${preOrderId}/status`,
        patchData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );

      newData[itemIndex] = { ...newData[itemIndex], ...patchData };
      setData(newData); // Reflect the update in the UI immediately

      alert("🎉 Payment Link Sent Successfully!");
      fetchPreOrders();
    } catch (error) {
      console.error("Error in payment link process:", error.response ? error.response.data : error.message);
      alert("❌ There was an error creating the payment link. Please try again.");
    } finally {
      setIsLoading(false); // End loading after all operations are complete
    }
  };

  const closeModal = () => {
    setStatusOpen(false);
  };


  const handleCheckboxChange = async (index) => {
    const itemIndex = (currentPage - 1) * itemsPerPage + index; // Calculate the actual index in the data array
    const currentItem = data[itemIndex];
    const newWithMaterial = !currentItem.with_material; // Toggle the `with_material` status

    try {
      setIsLoading(true)
      const response = await axios.patch(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${currentItem._id}/withmaterial/${newWithMaterial}`,
        {}, // Pass an empty object as data since it's not required
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );
      const newData = [...data];
      newData[itemIndex] = response.data;
      setData(newData);
      setIsLoading(false)
    } catch (error) {
      console.error("Failed to update with_material status:", error.message);
      setIsLoading(false)
      alert("Failed to update. Please try again.");
    }
  };
  const modelToTonMapping = {
    "S10": "1 ton",
    "S20": "2 ton",
    "C20": "2 ton",
    "C30": "3 ton",
    "S15": "1.5 ton"
  };


  // const downloadS3File = async (fileKey) => {
  //   try {
  //     if (!fileKey) {
  //       console.error("File key is required");
  //       return;
  //     }

  //     // Generate a pre-signed URL
  //     const command = new GetObjectCommand({
  //       Bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
  //       Key: `invoices/${fileKey}`,
  //     });
  //     const presignedUrl = await getSignedUrl(s3Client, command, { expiresIn: 3600 });

  //     // Fetch file from S3
  //     const fileResponse = await fetch(presignedUrl);
  //     if (!fileResponse.ok) throw new Error("Failed to download file");

  //     const fileBlob = await fileResponse.blob();
  //     const downloadUrl = window.URL.createObjectURL(fileBlob);

  //     // Create and trigger file download
  //     const anchor = document.createElement("a");
  //     anchor.href = downloadUrl;
  //     anchor.download = fileKey;
  //     document.body.appendChild(anchor);
  //     anchor.click();

  //     // Cleanup
  //     document.body.removeChild(anchor);
  //     window.URL.revokeObjectURL(downloadUrl);

  //     // console.log("File downloaded successfully");
  //   } catch (error) {
  //     console.error("Error downloading file:", error);
  //   }
  // };


  const downloadFileFromBackend = async (fileKey) => {
    try {
      if (!fileKey) {
        console.error("File key is required");
        return;
      }

      // returns URL string — NOT object
      const presignedUrl = await generatePresignedUrl(fileKey);

      if (!presignedUrl) {
        throw new Error("Failed to get pre-signed URL");
      }

      // fetch from S3
      const fileResponse = await fetch(presignedUrl);
      if (!fileResponse.ok) throw new Error("Failed to download file");

      const blob = await fileResponse.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const anchor = document.createElement("a");
      anchor.href = blobUrl;
      anchor.download = fileKey; // rename to original filename
      anchor.click();

      window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
      console.error("Download failed:", error);
    }
  };





  // Example usage inside a React component
  const piDownloadHandler = (s3Url) => {
    if (!s3Url) {
      console.error("Download URL is missing");
      return;
    }
    const fileKey = s3Url.split("/").pop(); // Extract filename from URL
    downloadFileFromBackend(fileKey);
  };

  const getFilterCount = () => {
    let count = 0;
    if (filters.verification) count++;
    if (filters.token) count++;
    if (filters.installationStatus) count++;
    if (filters.dateRange.start && filters.dateRange.end) count++;
    return count;
  };


  const handleExportExcel = () => {
    const exportData = filteredData.length > 0 ? filteredData : data;

    if (!exportData || exportData.length === 0) {
      alert("No data to export.");
      return;
    }

    const excelData = exportData.map((item) => {
      const transactionSummary = Array.isArray(item.aproveldata?.transactions)
        ? item.aproveldata.transactions
          .map((tx, i) => {
            const approveAmount = Number(tx.approveAmount || 0);
            const amount = Number(tx.amount || 0);

            if (approveAmount > 0) {
              const approvedOn = tx.approveDate
                ? new Date(tx.approveDate).toLocaleDateString()
                : "N/A";
              return ` Approved: ₹${approveAmount} (on ${approvedOn})`;
            } else if (amount > 0) {
              const uploadedOn = tx.uploadDate
                ? new Date(tx.uploadDate).toLocaleDateString()
                : "N/A";
              return ` Pending: ₹${amount} (uploaded on ${uploadedOn})`;
            } else {
              return null;
            }
          })
          .filter(Boolean)
          .join("\n") // <-- NEWLINE separator
        : "No Transactions";

      return {
        Customer: item.customer.name,
        Executive: item.executive_id || "",
        TotalReceivedAmount: item.TotalReceivedAmount,
        Token: item.TotalReceivedAmount > 0 ? "Received" : "Pending",
        Verification:
          item.verificationDetails &&
            Object.keys(item.verificationDetails).length > 0
            ? "Done"
            : "Not Done",
        PreOrderDate: new Date(item.preOrdertimestamp).toLocaleDateString(),
        AgreementSigned: item.isAgreementSigned ? "Yes" : "No",
        DocumentApproved: item.isDocumentApprove ? "Yes" : "No",
        // Shipping Address
        "Shipping Address Line 1": item.customer_shipping_address?.address_line1 || "",
        "Shipping Address Line 2": item.customer_shipping_address?.address_line2 || "",
        "Shipping City": item.customer_shipping_address?.city || "",
        "Shipping Pincode": item.customer_shipping_address?.pincode || "",
        "Shipping State": item.customer_shipping_address?.state || "",
        "Shipping Contact Person": item.customer_shipping_address?.contactPerson || "",
        "Shipping Contact Number": item.customer_shipping_address?.contactNumber || "",

        // Billing Address
        "Billing Address Line 1": item.customer_billing_address?.address_line1 || "",
        "Billing Address Line 2": item.customer_billing_address?.address_line2 || "",
        "Billing City": item.customer_billing_address?.city || "",
        "Billing Pincode": item.customer_billing_address?.pincode || "",
        "Billing State": item.customer_billing_address?.state || "",
        "Billing GST Number": item.customer_billing_address?.gst_number || "",
        "Transactions Summary": transactionSummary,
      }
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

    XLSX.writeFile(workbook, "Order_Report.xlsx");
  };

  return (
    <div className="flex flex-col w-full h-full p-4">
      <div className="flex justify-between items-center border-b-2 border-gray-300 pb-2 mb-4">
        <p className="text-lg font-semibold">Hello {user}</p>
        <div className="flex items-center">
          <p className="text-primary mr-2 text-2xl">Total Orders:</p>
          <p className="text-primary font-bold text-2xl">{totalOrganizations}</p>
        </div>
      </div>
      <div className="flex flex-wrap justify-between mb-4 gap-4">
        <div className="sm:flex flex-wrap gap-3">
          <div className="flex items-center gap-2 border-2 border-secondary rounded-md px-5 py-2">
            <FontAwesomeIcon icon={faMagnifyingGlass} size="xl" color="#A14996" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-60 text-black outline-none"
              placeholder={isAdminUser ? "Search By Customer and RM Name " : "Search By Customer"}
            />

          </div>
          <button
            onClick={() => setIsOpenFilter(true)}
            className="bg-white px-4 py-2 rounded-md text-primary border-primary border-2 mr-2"
          >
            <span><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z" />
            </svg>
            </span>
          </button>
          {getFilterCount() > 0 && (
            <span className="mt-2 text-primary text-lg font-medium">
              Orders found: {totalOrganizations}
            </span>
          )}
        </div>
        <div className="flex-wrap">
{isAdminUser ?
          <button
            className="bg-white px-4 py-2 rounded-md text-primary border-primary border-2 mr-2"
            onClick={handleOrderCreation}
          >
            CREATE ORDER
          </button>:""}
          <button
            className="bg-white px-4 py-2 rounded-md text-primary border-primary border-2 mr-2"
            onClick={quryhandler}
          >
            RAISE QUERY
          </button>
          {
            isAdminUser && (
              <button
                className="bg-white px-4 py-2 rounded-md text-primary border-primary border-2 mr-2"
                onClick={handleExportExcel}
              >
                Export to Excel
              </button>
            )
          }
          <button
            className="text-white px-4 py-2 rounded-md bg-primary"
            onClick={handleLogout}
          >
            <FontAwesomeIcon className="mr-1" icon={faRightFromBracket} />
            Logout
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        {loading ? (
          <p className="text-center">Loading data...</p>
        ) : totalOrganizations === 0 ? (
          <p className="text-center">No data available.</p>
        ) : (
          <>
            <table className="table-auto w-full border-collapse text-sm sm:text-base">
              <thead>
                <tr className="bg-secondary">
                  <th colSpan='2' className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Customer</th>
                  <th colSpan="3" className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Order Details</th>
                  {isAdminUser ? (
                    <th colSpan="13" className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      Payment Status
                    </th>
                  ) : (
                    <th colSpan="9" className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      Payment Status
                    </th>
                  )}

                </tr>
                <tr className="bg-secondary">
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Name</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Contact No</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Action</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Ac Details</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Add Material payment</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Pending Amount</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Total Recieved Amount</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Paid Amount</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Excess Amount</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Approval Pending</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Agreement Status</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Download PI</th>
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Status</th>
                  {isAdminUser ? (
                    <>
                      <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                        Agreement view
                      </th>
                      <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                        Customer Document view
                      </th>
                      <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                        RM Name
                      </th>
                      <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                        Creation Date
                      </th>
                    </>
                  ) : (
                    ''
                  )}
                  <th className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">Delete</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index} className="border-t border-gray-300">
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {item.customer.name}
                    </td>
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {item.customer.mobile}
                    </td>
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      <select
                        value={""}
                        onChange={(e) => handleActionChange(e, index, item)} // Pass item._id to the handler
                        className="border rounded px-2 py-1 bg-white focus:outline-none focus:ring-2 focus:ring-secondary"
                      >
                        {/* <option value="PISent">Select</option> */}
                        <option value="">Select</option>
                        <option value="edit">Edit</option>
                        <option value="site"> Request Site visit</option>
                        <option value="PiSent">Send PI</option>
                        {(item.isTokenLinkSent === false) ? <option value="token">Take Token</option> : ""}
                        {item.materialsdetails.length > 0 && (item.isMaterialPaymentLinkSent === false) ? <option value="onlymaterial">Only Material Payment</option> : ''}
                        <option value="recordpayment"> Record Payment</option>
                        {(item.isFullPaymentLinkSent === false) && <option value="fullpayment">Full Payment</option>}

                        {(user === "Karishma" ||
                          (item.isAgreementSigned && item.isDocumentApprove) &&
                          item.verificationDetails) && (
                            <option value="installtion">Request Installation</option>
                          )}

                        <option value="sendAgreement">Send Agreement</option>
                        <option value="uploadPhysicalAgreement">Upload CL Agreement</option>
                        <option value="customerDocument">KYC Document</option>
                        <option value="customerprofile">Customer Profile</option>
                        {
                          isAdminUser && (
                            <option value="verificationForm">Verification Form</option>
                          )
                        }
                      </select>
                    </td>
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {/* AC Details */}
                      {item.AcDetails.map((acDetail) => {
                        const tonnage = modelToTonMapping[acDetail.model] || "Unknown ton";
                        return `${acDetail.ac_type} - ${acDetail.quantity} AC (${tonnage})`;
                      }).join(', ')}

                      {/* Divider if materials exist */}
                      {item.materialsdetails && item.materialsdetails.length > 0 && <br />}

                      {/* Materials Details */}
                      {item.materialsdetails && item.materialsdetails.length > 0 &&
                        item.materialsdetails.map((material) => {
                          // Check if the material name contains "copper"
                          const unit = material.material_name.toLowerCase().includes('copper') ? 'feet' : 'pcs';
                          return `${material.material_name} - ${material.quantity} ${unit}`;
                        }).join(', ')}
                      {item.take3MonthPayment && (
                        <>
                          <br />
                          <span className="inline-block mt-1 px-2 py-1 text-xs font-medium text-green-800 bg-green-100 border border-purple-200 rounded">
                            Billing Includes Quarter 1 Subscription
                          </span>
                        </>
                      )}
                    </td>

                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2 text-center">
                      <input
                        type="checkbox"
                        checked={item.with_material}
                        onChange={() => handleCheckboxChange(index)}
                        className="form-checkbox h-4 w-4 text-secondary"
                      />
                    </td>

                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {item.total_pending_amount ?? item.pending_amount}
                    </td>
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {item.TotalReceivedAmount}
                    </td>
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {item.paidamount}
                    </td>
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {Math.max(0, item.paidamount - (item.material_totalAmount + item.Ac_totalAmount))}
                    </td>
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {item.aproveldata?.transactions?.reduce((sum, transaction) => sum + (transaction.amount || 0), 0) || 0}
                    </td>
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      {item.isAgreementSigned === undefined ? (
                        <span className="text-gray-500">Pending</span>
                      ) : item.isAgreementSigned ? (
                        <span className="text-green-600 font-medium">Signed</span>
                      ) : (
                        <span className="text-red-600 font-medium">Not Signed</span>
                      )}
                    </td>
                    <td className="border-gray-300 px-2 py-2 sm:px-4 sm:py-2 flex justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="#0424c3"
                        className="size-6 cursor-pointer justify-center items-center"
                        onClick={() => piDownloadHandler(item.Pilink)}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                        />
                      </svg>
                    </td>


                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                      <button onClick={() => { setStatusOpen(true); setselectedoderid(item._id) }} className="p-1 text-blue-500 hover:text-blue-700">
                        <Info size={18} />
                      </button>
                    </td>
                    {
                      isAdminUser ? (
                        <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                          {
                            item?.pdfLink ? (
                              <button
                                onClick={() => {
                                  setagreementview(true);
                                  setSelectedPdf(item);

                                }}
                                className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                              >
                                View PDF
                              </button>

                            ) : ""
                          }
                        </td>
                      ) : ""
                    }
                    {
                      isAdminUser ? (
                        <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                          {item?.customerDocuments?.length > 0 ? (
                            <button
                              onClick={() => {
                                setCustomerDocumentview(true);
                                setSelectedPdf(item);

                              }}
                              className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                            >
                              View Document
                            </button>
                          ) : ""
                          }
                        </td>
                      ) :
                        ""
                    }
                    {
                      isAdminUser ? (
                        <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">

                          {item.executive_id}
                        </td>
                      ) :
                        ""
                    }
                    {
                      isAdminUser ? (
                        <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2">
                          {/* {item.preOrdertimestamp.slice(0, 16)} */}
                          {new Date(item.preOrdertimestamp).toLocaleString("en-GB", {
                            timeZone: "UTC",
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </td>
                      ) :
                        ""
                    }
                    <td className="border border-gray-300 px-2 py-2 sm:px-4 sm:py-2" >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="red" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="size-6" onClick={() => deleteHandler(item._id)} >
                        <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                      </svg>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {isLoading && (
              <div className="fixed inset-0 bg-gray-50 bg-opacity-70 overflow-y-auto h-full w-full flex items-center justify-center">
                <LoadingAnimation />
              </div>
            )}
            {
              statusOpen && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4 p-6 relative">
                    {/* Close Button */}
                    <button
                      onClick={closeModal}
                      className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-xl"
                    >
                      &times;
                    </button>
                    <div>
                      <h3 className="block text-lg font-medium text-gray-700">
                        Installation Status
                      </h3>
                      <p>
                        {installationStatus}
                      </p>
                    </div>
                    <br></br>
                    <h3 className="block text-lg font-medium text-gray-700">
                      Approval Payment Status
                    </h3>
                    <p>
                      {(() => {
                        // Find the selected preorder object from the currentItems array
                        const selectedOrder = data.find(item => item._id === selectpreoderid);

                        // If no order is found, return a default message
                        if (!selectedOrder) return "No Order Selected";

                        // Get the transactions array
                        const transactions = selectedOrder.aproveldata?.transactions || [];

                        // If no transactions exist, return a default message
                        if (transactions.length === 0) return "No Transactions";

                        // Process the last transaction for display

                        return transactions
                          .map(transaction =>
                            transaction.amount > 0
                              ? `${transaction.amount} - Requested`
                              : `${transaction.approveAmount} - Success`
                          )
                          .join(", "); // Join all transaction statuses with a comma
                      })()}
                    </p>

                  </div>
                </div>
              )
            }
            {isOpen && (
              <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-lg w-full max-w-md mx-4 p-6">
                  <h3 className="text-lg font-semibold mb-4">Record Payment</h3>
                  {/* <div className="mb-4 flex items-center gap-x-6">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        value="normal"
                        checked={approvalType === "normal"}
                        onChange={() => setApprovalType("normal")}
                        className="mr-2"
                      />
                      Normal Approval
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        value="special"
                        checked={approvalType === "special"}
                        onChange={() => setApprovalType("special")}
                        className="mr-2"
                      />
                      Special Approval
                    </label>
                  </div> */}
                  {approvalType === "normal" ? (
                    <>
                      {/* Document Type Dropdown */}
                      <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Payment Type:</label>
                        <select
                          value={recordType}
                          onChange={(e) => setrecordType(e.target.value)}
                          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                        >
                          <option value="" disabled>
                            Select Payment Type
                          </option>
                          <option value="custom">Payment Link</option>
                          <option value="qrcode">UPI/NEFT/RTGS</option>
                        </select>
                      </div>

                      {/* File Upload */}
                      {recordType === "qrcode" ?
                        <div className="mb-4">
                          <label
                            htmlFor="attachment"
                            className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer hover:bg-blue-600 transition"
                          >
                            Upload Attachment
                          </label>
                          <input
                            type="file"
                            id="attachment"
                            onChange={handleFileUpload}
                            className="hidden"
                          />
                          {attachment && (
                            <div className="mt-2">
                              <div className="flex items-center space-x-2">
                                <span className="text-sm text-gray-600">{attachment.name}</span>
                                <button
                                  onClick={removeAttachment}
                                  className="text-red-500 hover:underline text-sm"
                                >
                                  Delete
                                </button>
                              </div>
                              {attachmentPreview &&
                                (
                                  <div className="mt-2">
                                    {attachment.type === "application/pdf" ? (
                                      <iframe
                                        src={attachmentPreview}
                                        width="100%"
                                        height="250px"
                                      ></iframe>
                                    ) : (
                                      <img
                                        src={attachmentPreview}
                                        alt="Preview"
                                        className="w-48 h-48 object-cover rounded border border-gray-300"
                                      />
                                    )}
                                  </div>
                                )}
                            </div>
                          )}
                        </div> : ""}

                      {/* Total Amount */}
                      <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Enter Total Amount:</label>
                        <input
                          type="text"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          placeholder="₹"
                          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {/* Special Approval Comment */}
                      <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Write a Comment:</label>
                        <textarea
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                          placeholder="Add your comments here..."
                          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
                        ></textarea>
                      </div>
                    </>
                  )}

                  {/* Action Buttons */}
                  <div className="flex justify-end space-x-4">
                    <button
                      onClick={CancelHanlder}
                      className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100 transition"
                    >
                      Cancel
                    </button>
                    <button
                      className="px-4 py-2 bg-primary text-white rounded hover:bg-purple-700 transition"
                      onClick={handleSubmit}
                    >
                      {recordType === "qrcode" ? "Send Approval Request" : "Send paymentLink"}
                    </button>
                  </div>
                </div>
                {isLoading && (
                  <div className="fixed inset-0 bg-gray-50 bg-opacity-70 overflow-y-auto h-full w-full flex items-center justify-center">
                    <LoadingAnimation />
                  </div>
                )}
              </div>
            )}
            {isOpensite && (
              <SiteSurvey siteSurvey={siteSurvey} setSiteSurvey={setSiteSurvey} isOpensite={isOpensite} setIsOpensite={setIsOpensite} selectpreoderid={selectpreoderid} apiMaterials={apiMaterials} />
            )

            }
            {isOpenInstallation && (
              <Installation isOpenInstallation={isOpenInstallation} setIsOpenInstallation={setIsOpenInstallation} setInstallationDetails={setInstallationDetails} installationDetails={installationDetails} selectpreoderid={selectpreoderid} apiMaterials={apiMaterials} />
            )

            }  {
              isSendAgreementOpen && (
                <SendAgreement isModalOpen={isSendAgreementOpen} setIsModalOpen={setIsSendAgreementOpen} itemId={selectpreoderid} isPhysicalAgreement={false} isCustomerDocument={false} />
              )
            }
            {
              isPhysicalAgreementOpen && (
                <SendAgreement isModalOpen={isPhysicalAgreementOpen} setIsModalOpen={setIsPhysicalAgreementOpen} itemId={selectpreoderid} isPhysicalAgreement={true} isCustomerDocument={false} />
              )
            }
            {
              isCustomerDocumentOpen && (
                <SendAgreement isModalOpen={isCustomerDocumentOpen} setIsModalOpen={setIsCustomerDocumentOpen} itemId={selectpreoderid} isPhysicalAgreement={false} isCustomerDocument={true} customer_id={selectCustomerId} />
              )
            }
            {
              customerprofileOpen && (
                <CustomerProfileForm customerprofileOpen={customerprofileOpen} itemId={selectpreoderid} setCustomerprofileOpen={setCustomerprofileOpen} />
              )
            }
            {
              agreementview && (
                <AgreementView agreementview={agreementview} selectpdf={selectpdf} setagreementview={setagreementview} isDocument={false} />
              )
            }
            {
              customerDocumentview && (
                <AgreementView agreementview={customerDocumentview} selectpdf={selectpdf} setagreementview={setCustomerDocumentview} isDocument={true} />
              )
            }
            {
              isOpenFilter && (
                <FilterModal setIsOpenFilter={setIsOpenFilter} setFilters={setFilters} filters={filters} isOpenFilter={isOpenFilter} isAdmin={isAdminUser ? true : false} />
              )
            }



            <div className="flex justify-center items-center space-x-2 mt-[1%]">
              <button
                className="bg-gray-300 hover:bg-gray-400 text-black py-1 px-3 rounded"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              {Array.from({ length: totalPages }, (_, index) => {
                const pageNumber = index + 1;

                if (
                  pageNumber === 1 ||
                  pageNumber === totalPages ||
                  (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1) ||
                  (pageNumber <= 10 && currentPage <= 7) ||
                  (pageNumber >= totalPages - 9 && currentPage >= totalPages - 6)
                ) {
                  return (
                    <button
                      key={pageNumber}
                      className={`py-1 px-3 rounded ${currentPage === pageNumber
                        ? "bg-primary text-white"
                        : "bg-gray-300 hover:bg-gray-400 text-black"
                        }`}
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  );
                }

                if (
                  (pageNumber === 2 && currentPage > 7) ||
                  (pageNumber === totalPages - 1 && currentPage < totalPages - 6) ||
                  (pageNumber === currentPage - 2 && pageNumber > 10 && currentPage > 7) ||
                  (pageNumber === currentPage + 2 && pageNumber < totalPages - 9 && currentPage < totalPages - 6)
                ) {
                  return (
                    <span key={pageNumber} className="px-1">
                      ...
                    </span>
                  );
                }

                return null;
              })}

              <button
                className="bg-gray-300 hover:bg-gray-400 text-black py-1 px-3 rounded"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default HomeBackend;
